var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":"https://esaj.ir/blog/wp-content/uploads/2021/01/57589707-640x392.jpg","max-width":"70px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }